import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const metricsWrapper = {
  element: '#marketing-performance > div',
  popover: {
    title: 'Performance Metrics',
    description: 'Get a quick, high-level look at how your campaign is performing with the metrics rollup.',
    side: 'right',
    align: 'center',
    showButtons: ['next']
  }
};

export const metricsGranularity = {
  element: '#marketing-performance > div > div.controls',
  popover: {
    title: 'Metrics Granularity',
    description:
      'Switch between daily and monthly performance metrics using the granularity buttons. You can also toggle between line and bar chart views for easier analysis.',
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const timePeriodBtns = document.querySelectorAll(
        '#marketing-performance > div > div.controls > div:nth-child(2)'
      );
      const chartTypeBtns = document.querySelectorAll('#marketing-performance > div > div.controls > div:nth-child(4)');

      const popoverNextBtn = document.querySelector(
        'span.driver-popover-navigation-btns > button.driver-popover-next-btn'
      );

      if (
        timePeriodBtns &&
        chartTypeBtns &&
        popoverNextBtn &&
        !timePeriodBtns[0].children[1].classList.contains('active')
      ) {
        popoverNextBtn.disabled = true;
        popoverNextBtn.classList.add('driver-popover-btn-disabled');

        setTimeout(() => {
          timePeriodBtns[0].children[1].click();
        }, 800);

        setTimeout(() => {
          chartTypeBtns[0].children[1].click();

          popoverNextBtn.disabled = false;
          popoverNextBtn.classList.remove('driver-popover-btn-disabled');
        }, 2800);
      }
    }
  }
};

export const metricsDeliveries = {
  element: '#marketing-performance > div > div.metrics-summary.selections.bar > div:nth-child(1)',
  popover: {
    title: 'Deliveries',
    description: 'Deliveries show how many times your campaign was successfully sent to its audience.',
    side: 'top',
    align: 'center'
  }
};

export const metricsImpressions = {
  element: '#marketing-performance > div > div.metrics-summary.selections.bar > div:nth-child(2)',
  popover: {
    title: 'Impressions',
    description: 'Impressions count how many times your ad was viewed within the selected time range.',
    side: 'top',
    align: 'center'
  }
};

export const metricsClicks = {
  element: '#marketing-performance > div > div.metrics-summary.selections.bar > div:nth-child(3)',
  popover: {
    title: 'Clicks',
    description: 'Clicks track how many times your ad was clicked during the selected time range.',
    side: 'top',
    align: 'center'
  }
};

export const metricsReach = {
  element:
    '#marketing-performance > div > div.metrics-summary.selections.bar > div.metric.reach.selected > div.reach-metric',
  popover: {
    title: 'Reach',
    description: 'Reach is the total number of unique recipients who saw your ad during the selected time range.',
    side: 'right',
    align: 'center'
  }
};

export const metricsCTR = {
  element:
    '#marketing-performance > div > div.metrics-summary.selections.bar > div.metric.reach.selected > div.ctr-metric',
  popover: {
    title: 'Click-Through Rate',
    description: 'CTR shows the percentage of recipients who clicked your ad compared to the total number of views.',
    side: 'right',
    align: 'center'
  }
};

export const metricsCTRR = {
  element:
    '#marketing-performance > div > div.metrics-summary.selections.bar > div.metric.reach.selected > div.ctrr-metric',
  popover: {
    title: 'Click-to-Recipient Rate',
    description: 'CTRR shows the percentage of clicks recieved to the total number of unique recipients (reach).',
    side: 'right',
    align: 'center'
  }
};
